import { USER_IS_LOGIN_STORE_KEY, USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from "@/utils/constant";
import { getStorage, removeStorage, setStorage } from '@/utils/tools'
import { Mask } from "@/components/mask/index";
import { messages } from '@/i18n'
import Vue, {ref} from 'vue'
import './index.css'
import { fetchLogin, fetchRegister, fetchGetTmpUuid } from '@/api'
import Cookies from "js-cookie";
import { Toast } from 'vant';
import { getPathLang, setUserInfo } from '@/utils/base'
export const isCurLogin = ref(false)


export class Login {
  constructor() {
  }

  isLogin() {
    return +getStorage(USER_IS_LOGIN_STORE_KEY) === 1
  }

   async logout() {
    removeStorage(USER_IS_LOGIN_STORE_KEY)
    Toast(messages[getPathLang()]['logout_success'])
    Cookies.remove(USER_ID_COOKIES_KEY)
    Cookies.remove(USER_TOKEN_COOKIES_KEY)
    isCurLogin.value = false
    return await fetchGetTmpUuid();
  }

  initLoginView(successCallback = function(){}) {
    const that = this
    this.mask = new Mask({
      maskStyle: 'z-index: 999;',
      closeOnClickOverlay: false,
      isDestroy:true,
      slot: () => {
        return Vue.extend({
          data() {
            return {
              flag: 'login',
              userName: '',
              password: '',
          
            }
          },
          methods: {
            tt(key){
              return messages[getPathLang()][key] || ''
            },
            handleClickClose() {
              that.mask.close()
            },
            handleCheckout() {
              this.flag = this.flag === 'login' ? 'register' : 'login'
              this.userName = ''
              this.password = ''
            },

            async handleRegister() {
              const res = await fetchRegister({
                user_name: this.userName,
                password: this.password,
                tmp_user_id: Cookies.get(USER_ID_COOKIES_KEY)
              })
              Toast(this.tt('register_success'))
              this.handleLogin()

              // this.handleCheckout()
              // this.userName = ''
              // this.password = ''
            },
            async handleLogin() {
              const res = await fetchLogin({
                user_name: this.userName,
                password: this.password,
              })
              setUserInfo(res.user_id, res.accessToken)
              setStorage(USER_IS_LOGIN_STORE_KEY, 1)
              Toast(this.tt('login_success'))
              isCurLogin.value = true;
              setTimeout(() => {
                that.mask.close()
                successCallback();
              }, 500);
            },
            handleClickBtn() {
              if(this.userName === '' || this.password === '') {
                Toast(this.tt('username_or_password_cannot_be_empty'))
                return
              }
              if(this.userName.length < 8 || this.password.length < 8) {
                Toast(this.tt('username_or_password_length_must_be_greater_than_8'))
                return
              }
              if(this.flag === 'login') {
                this.handleLogin()
              } else {
                this.handleRegister()
              }
            }
          },  
          render() {
            return (
              <div class="top-img pages login-pages">
                <div class={['login-nav', 'flex', 'items-center']}>
                  <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/icon_arrowL.png" alt="" onClick={() => this.handleClickClose()}/>
                </div>
                <div class="login-logo flex justify-center items-center">
                  <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/logo.png" alt="" />
                    Novelfreedom
                </div>
                <div class="login-content">
                  <div class="login-content-title">{this.flag === 'login'? this.tt('login') : this.tt('register') }</div>
                  <div class="login-input flex items-center">
                    <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/user-icon.png" alt="" />
                      <input type="text" placeholder={this.tt('user')} value={this.userName} onInput={e => {
                        this.userName = e.target.value
                      }}/>
                  </div>
                  <div class="login-input flex items-center">
                    <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/password.png" alt="" />
                      <input type="password" placeholder={this.tt('password')} value={this.password} onInput={e => {
                        this.password = e.target.value
                      }}/>
                  </div>
                </div>
                <div class={['login-btn', 'flex', 'justify-center', 'items-center', 'mx-auto', this.userName.length > 0 ? 'login-btn__active' : 'login-btn__none']} 
                  onClick={() => this.handleClickBtn()}
                >
                  {this.flag === 'login'? this.tt('login') : this.tt('register')}
                </div>
                <div class="login-checkout" onClick={() => this.handleCheckout()}>
                  {this.flag === 'login' ? this.tt('register') : this.tt('login')}
                </div>
                <div class="login-text text-center w-full">
                  {this.tt('by_continuing_you_agree_with_the')} <a onClick={() => {
                    window.location.href = window.location.origin + '/privacy'
                  }}>{ this.tt('privacy_policy') }</a> {this.tt('and')} <a onClick={() => {
                    window.location.href = window.location.origin + '/service'
                  }}>{ this.tt('terms_of_service') }</a>
                </div>
              </div>
            )
          }
        })
      },
    })
    this.mask.init();
  }

  showLoginView() {
    this.mask.show()
  }
}

export const login = new Login()